<div #origin [class.hover-effect]="!matStyle()" fxLayout="row">
  @if (!isOpen) {
    <button
      (click)="open(dropdown, origin); $event.stopPropagation()"
      (focus)="openFromFocus(dropdown, origin)"
      [attr.aria-expanded]="isOpen"
      [attr.aria-label]="label || placeholder() | translate"
      aria-haspopup="listbox"
      class="mat-subtitle-2 no-pad select-trigger"
      fxFlex="grow"
      type="button"
    >
      @if (!originTpl()) {
        @if (matStyle()) {
          <!-- Display-only copy of the selection: not focusable, hidden from AT (the button carries the accessible name). -->
          <mat-form-field
            [formGroup]="selectFormGroup"
            appearance="outline"
            aria-hidden="true"
            class="pointer-events-none"
            fxFlex="grow"
          >
            @if (placeholder()) {
              <mat-label>{{ placeholder() | translate }}</mat-label>
            }
            <mat-error>{{ error() | translate }}</mat-error>
            <input
              [formControlName]="selectControlName"
              [required]="require()"
              [value]="label | translate"
              autocomplete="off"
              class="mat-subtitle-2"
              data-testid="select-trigger-input"
              matInput
              tabindex="-1"
            />
          </mat-form-field>
        } @else {
          @if (placeholder() && !label) {
            <p class="on-surface-medium no-pad p-1">
              {{ placeholder() | translate }}
            </p>
          }
          <p class="no-pad p-1 on-surface">{{ label | translate }}</p>
        }
      }
      <ng-template *ngTemplateOutlet="originTpl() ?? null" />
    </button>
  } @else {
    @if (matStyle()) {
      <mat-form-field appearance="outline" fxFlex="grow">
        @if (placeholder()) {
          <mat-label>{{ placeholder() | translate }}</mat-label>
        }
        <input
          (click)="$event.stopPropagation()"
          (keydown)="onSearchKeydown($event)"
          [attr.aria-activedescendant]="
            activeIndex() >= 0 ? 'select-option-' + activeIndex() : null
          "
          [formControl]="searchControl"
          [required]="require()"
          aria-autocomplete="list"
          aria-expanded="true"
          autocomplete="off"
          class="mat-subtitle-2"
          data-testid="select-search-input"
          matInput
          recrewtAutofocus
          role="combobox"
        />
        <mat-icon aria-hidden="true" matSuffix>search</mat-icon>
      </mat-form-field>
    } @else {
      <input
        (click)="$event.stopPropagation()"
        (keydown)="onSearchKeydown($event)"
        [attr.aria-activedescendant]="activeIndex() >= 0 ? 'select-option-' + activeIndex() : null"
        [formControl]="searchControl"
        [placeholder]="placeholder() | translate"
        aria-autocomplete="list"
        aria-expanded="true"
        class="mat-styled-input mat-subtitle-2"
        fxFlex="grow"
        recrewtAutofocus
        role="combobox"
        type="text"
      />
    }
  }

  <ng-template #dropdown>
    <div class="select-menu mat-elevation-z3">
      @if ((loading$() | async) === false || (loading$() | async) == null) {
        <cdk-virtual-scroll-viewport
          [style.height.px]="visibleOptions() * 48"
          class="select-menu-inner"
          itemSize="48"
          role="listbox"
        >
          @if (!filteredOptions().length) {
            <div class="no-results-item on-surface-medium">
              {{ 'PLACEHOLDER.no_results' | translate }}
            </div>
          }
          <div
            (click)="select(option)"
            *cdkVirtualFor="let option of filteredOptions(); index as i"
            [attr.aria-selected]="isActive(option)"
            [class.active]="isActive(option)"
            [class.keyboard-active]="i === activeIndex()"
            [id]="'select-option-' + i"
            class="select-item"
            data-testid="select-option"
            matRipple
            role="option"
          >
            @if (!optionTpl()) {
              {{ displayLabel(option) | translate }}
            }
            <ng-template
              *ngTemplateOutlet="optionTpl() ?? null; context: { $implicit: option, idx: i }"
            />
          </div>
        </cdk-virtual-scroll-viewport>
      } @else {
        <div style="height: 204px; padding-top: 4px">
          @for (i of [0, 1, 2, 3]; track i) {
            <ngx-skeleton-loader
              [theme]="{
                width: '90%',
                height: '20px',
                margin: '12px 5%',
                padding: '0',
                backgroundColor: '#ebebeb',
              }"
            />
          }
        </div>
      }
    </div>
  </ng-template>
</div>
